import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';

import { FETCH_INSTANCE_STARTED, fetchInstancefulfilled } from './actions';

const fetchInstanceEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_INSTANCE_STARTED),
    mergeMap(() =>
      from(Safescarf.fetchSafescarfInstance()).pipe(
        mergeMap((response: { data: unknown }) => of(fetchInstancefulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

export default combineEpics(fetchInstanceEpic);
